module.exports = __webpack_public_path__ + "static/media/IMG_1207.cac221d7.jpg";